import cx from 'classnames'

export const Card = ({ children, className, ...props }) => (
  <section className={cx('tw:rounded-card tw:border tw:border-default tw:bg-surface', className)} {...props}>
    {children}
  </section>
)
